import { useContext } from 'react';

import type { PetitionMitaAlternateImageData } from 'src/app/pages/petition/details/shared/types';

import { MitaContext } from './context';

export function useMitaPhoto(): PetitionMitaAlternateImageData | undefined {
	return useContext(MitaContext);
}
